import { Popover, Tag } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CorpGroup, CorpUser, EntityType } from '../../../../../types.generated';
import { CustomAvatar } from '../../../../shared/avatar';
import { useEntityRegistry } from '../../../../useEntityRegistry';
import { DATAHUB_SYSTEM } from '../../../../ingest/source/utils';

type Props = {
    actor: CorpUser | CorpGroup;
    popOver?: React.ReactNode;
    closable?: boolean | undefined;
    onClose?: () => void;
};

const ActorTag = styled(Tag)`
    padding: 2px;
    max-height: 24px;
    padding-right: 6px;
    margin-bottom: 8px;
    align-items: center;
    display: inline-flex;
    color: #4c4e54 !important;
    border-radius: 16px !important;
    background-color: #f8f8f9 !important;
`;

export const ExpandedActor = ({ actor, popOver, closable, onClose }: Props) => {
    const entityRegistry = useEntityRegistry();

    let name = '';
    let path = `${entityRegistry.getEntityUrl(actor.type, actor.urn)}`;

    if (actor.__typename === 'CorpGroup') {
        name = entityRegistry.getDisplayName(EntityType.CorpGroup, actor);
    }
    if (actor.__typename === 'CorpUser') {
        name = entityRegistry.getDisplayName(EntityType.CorpUser, actor);
    }

    if (name === DATAHUB_SYSTEM) {
        name = 'System';
        path = '#';
    }

    const pictureLink = (actor.__typename === 'CorpUser' && actor.editableProperties?.pictureLink) || undefined;

    return (
        <ActorTag onClose={onClose} closable={closable}>
            <Link className="truncate" title={name} to={path}>
                <CustomAvatar
                    size={16}
                    name={name}
                    photoUrl={pictureLink}
                    useDefaultAvatar={false}
                    style={{ marginRight: 4 }}
                />
                {(!popOver && <>{name}</>) || (
                    <Popover overlayStyle={{ maxWidth: 200 }} placement="left" content={popOver}>
                        {name}
                    </Popover>
                )}
            </Link>
        </ActorTag>
    );
};
